import { render, staticRenderFns } from "./BulkPrintDataMatrix.vue?vue&type=template&id=6f894ce1&scoped=true&"
import script from "./BulkPrintDataMatrix.vue?vue&type=script&lang=js&"
export * from "./BulkPrintDataMatrix.vue?vue&type=script&lang=js&"
import style0 from "./BulkPrintDataMatrix.vue?vue&type=style&index=0&id=6f894ce1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f894ce1",
  null
  
)

export default component.exports